<template>
  <generic-modal
    :title="$t('messages')"
    :buttons="buttons"
    ref="generic_modal"
    :is_wide="true"
  >
    <message-datatable ref="message_datatable" />
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import MessageDatatable from "./MessageDatatable.vue";

export default {
  name: "MessagesModal",
  components: { GenericModal, MessageDatatable },
  data() {
    return {
      api_host,
      buttons: [
        // {
        //   text: this.$t("save"),
        //   class: "is-primary is-rounded",
        //   icon: "fa fa-save",
        //   click: this.save,
        //   disabled: "this.is_form_invalid",
        // },
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(campaign_uuid) {
      // console.log("show_modal");
      let v = this;
      v.set_initial_state();
      v.$refs.message_datatable.init(campaign_uuid);
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
